export const VISIBILITY_OPTIONS = [
  { value: 0, label: "Brouillon" },
  { value: 1, label: "Publique" },
  { value: 2, label: "Amis" },
  { value: 4, label: "Mêmes Forums suivis" },
  { value: 5, label: "Groupes d'amis" },
];

export const PUBLISHED_VISIBILITY_OPTIONS = VISIBILITY_OPTIONS.filter(
  ({ value }) => value !== 0
);
